/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import { Provider } from 'react-redux';
import redux from './redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Context]
-------------------------------------------------------------------*/
import { TokenContext, UserContext, NotificationContext, LocationContext } from './context/container'
import { ___token, ___user, ___notification, ___location } from './context/define'
/*------------------------------------------------------------------
[End Context]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Storeage]
-------------------------------------------------------------------*/
import {reactLocalStorage} from 'reactjs-localstorage';
/*------------------------------------------------------------------
[End Storage]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Device]
-------------------------------------------------------------------*/
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
/*------------------------------------------------------------------
[End Device]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Online]
-------------------------------------------------------------------*/
import { Offline, Online, Detector } from "react-detect-offline";
/*------------------------------------------------------------------
[End Online]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Partials]
-------------------------------------------------------------------*/
import Meta from './screens/__partials__/meta';
import Navbar from './screens/__partials__/navbar';
import Header from './screens/__partials__/header';
import Content from './screens/__partials__/content';
import Footer from './screens/__partials__/footer';
/*------------------------------------------------------------------
[End Partials]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC, API_GET_REQUEST, API_LOGIN, API_TOKEN } from './api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screen]
-------------------------------------------------------------------*/
import AdminScreen from "./screens/@admin";
import LoginScreen from "./screens/authentication/login";
import RegisterScreen from "./screens/authentication/register";
import ForgetPasswordScreen from "./screens/forget_password";
import ActivationScreen from "./screens/activation";
import ActivationRedirectScreen from "./screens/activation/redirect";

import RedirectScreen from "./screens/301";
import NotFoundScreen from "./screens/404";
import OfflineScreen from "./screens/offline";

import GuestScreen from "./screens/guest/guest";

import GalleryScreen from "./screens/gallery";
import ImagesScreen from "./screens/images";
import VideoScreen from "./screens/video";
import ServicesScreen from "./screens/services";
import ProfileScreen from "./screens/profile";
import TestimonialScreen from "./screens/testimonial";

import PagesScreen from "./screens/pages";

import PostScreen from "./screens/post";
import PostBulletinScreen from "./screens/post/bulletin";
import PostEventScreen from "./screens/post/event";
import PostNewsScreen from "./screens/post/news";
import PostArticleScreen from "./screens/post/article";

import MailScreen from "./screens/mail";

// Forum
import ForumAdminScreen from "./screens/@forum";
import ForumHomeScreen from "./screens/@forum/home";
import ForumCallScreen from "./screens/@forum/call";
import ForumChatScreen from "./screens/@forum/chat";
import ForumLoginScreen from "./screens/@forum/@authentication/login";
import ForumRegisterScreen from "./screens/@forum/@authentication/register";
import ForumForgetPasswordScreen from "./screens/@forum/@forget_password";
import ForumActivationScreen from "./screens/@forum/@activation";
import ForumActivationRedirectScreen from "./screens/@forum/@activation/redirect";

import ForumEntryScreen from "./screens/@forum/@entry";

// Export
import ExportAdminScreen from "./screens/@admin/@export";
import ExportHomeScreen from "./screens/@admin/@export/home";
import ExportLoginScreen from "./screens/@admin/@export/@authentication/login";
import ExportRegisterScreen from "./screens/@admin/@export/@authentication/register";
import ExportForgetPasswordScreen from "./screens/@admin/@export/@forget_password";
import ExportActivationScreen from "./screens/@admin/@export/@activation";
import ExportActivationRedirectScreen from "./screens/@admin/@export/@activation/redirect";
import ExportPaymentScreen from "./screens/@admin/@export/payment";

// Otomotif
import OtomotifAdminScreen from "./screens/@admin/@otomotif";
import OtomotifHomeScreen from "./screens/@admin/@otomotif/home";
import OtomotifLoginScreen from "./screens/@admin/@otomotif/@authentication/login";
import OtomotifRegisterScreen from "./screens/@admin/@otomotif/@authentication/register";
import OtomotifForgetPasswordScreen from "./screens/@admin/@otomotif/@forget_password";
import OtomotifActivationScreen from "./screens/@admin/@otomotif/@activation";
import OtomotifActivationRedirectScreen from "./screens/@admin/@otomotif/@activation/redirect";
import OtomotifPaymentScreen from "./screens/@admin/@otomotif/payment";

// Mega Merah
import MegaMerahAdminScreen from "./screens/@admin/@megamerah";
import MegaMerahHomeScreen from "./screens/@admin/@megamerah/home";
import MegaMerahLoginScreen from "./screens/@admin/@megamerah/@authentication/login";
import MegaMerahRegisterScreen from "./screens/@admin/@megamerah/@authentication/register";
import MegaMerahForgetPasswordScreen from "./screens/@admin/@megamerah/@forget_password";
import MegaMerahActivationScreen from "./screens/@admin/@megamerah/@activation";
import MegaMerahActivationRedirectScreen from "./screens/@admin/@megamerah/@activation/redirect";
import MegaMerahPaymentScreen from "./screens/@admin/@megamerah/payment";

// Tour
import TourAdminScreen from "./screens/@admin/@tour";
import TourHomeScreen from "./screens/@admin/@tour/home";
import TourLoginScreen from "./screens/@admin/@tour/@authentication/login";
import TourRegisterScreen from "./screens/@admin/@tour/@authentication/register";
import TourForgetPasswordScreen from "./screens/@admin/@tour/@forget_password";
import TourActivationScreen from "./screens/@admin/@tour/@activation";
import TourActivationRedirectScreen from "./screens/@admin/@tour/@activation/redirect";
import TourPaymentScreen from "./screens/@admin/@tour/payment";

// School
import SchoolAdminScreen from "./screens/@admin/@school";
import SchoolHomeScreen from "./screens/@admin/@school/home";
import SchoolLoginScreen from "./screens/@admin/@school/@authentication/login";
import SchoolRegisterScreen from "./screens/@admin/@school/@authentication/register";
import SchoolForgetPasswordScreen from "./screens/@admin/@school/@forget_password";
import SchoolActivationScreen from "./screens/@admin/@school/@activation";
import SchoolActivationRedirectScreen from "./screens/@admin/@school/@activation/redirect";
import SchoolPaymentScreen from "./screens/@admin/@school/payment";

// SIMS (sistem informasi manajemen sekolah)
import SimsAdminScreen from "./screens/@admin/@sims/";
import SimsLoginScreen from "./screens/@admin/@sims/@authentication/login";
import SimsRegisterScreen from "./screens/@admin/@sims/@authentication/register";
import SimsForgetPasswordScreen from "./screens/@admin/@sims/@forget_password";
import SimsActivationScreen from "./screens/@admin/@sims/@activation";
import SimsActivationRedirectScreen from "./screens/@admin/@sims/@activation/redirect";

import SimsExportRaporScreen from "./screens/@admin/@sims/@export/rapor";
import SimsExportGuruScreen from "./screens/@admin/@sims/@export/guru";
import SimsExportSiswaScreen from "./screens/@admin/@sims/@export/siswa";
import SimsExportNilaiScreen from "./screens/@admin/@sims/@export/nilai";
import SimsExportKeuanganScreen from "./screens/@admin/@sims/@export/keuangan";
import SimsExportPenggajianScreen from "./screens/@admin/@sims/@export/penggajian";

// SIMPR (sistem informasi manajemen persatuan ruang)
import SimprAdminScreen from "./screens/@admin/@simpr/";
import SimprLoginScreen from "./screens/@admin/@simpr/@authentication/login";
import SimprRegisterScreen from "./screens/@admin/@simpr/@authentication/register";
import SimprForgetPasswordScreen from "./screens/@admin/@simpr/@forget_password";
import SimprActivationScreen from "./screens/@admin/@simpr/@activation";
import SimprActivationRedirectScreen from "./screens/@admin/@simpr/@activation/redirect";

import SimprHomeScreen from "./screens/@admin/@simpr/home";

// BPRB (Bidang Penataan Ruang Bangunan)
import SimprAdminBprbScreen from "./screens/@admin/@simpr/_@bprb";
import SimprLoginBprbScreen from "./screens/@admin/@simpr/_@bprb/@authentication/login";
import SimprRegisterBprbScreen from "./screens/@admin/@simpr/_@bprb/@authentication/register";
import SimprForgetPasswordBprbScreen from "./screens/@admin/@simpr/_@bprb/@forget_password";
import SimprActivationBprbScreen from "./screens/@admin/@simpr/_@bprb/@activation";
import SimprActivationRedirectBprbScreen from "./screens/@admin/@simpr/_@bprb/@activation/redirect";

import SimprHomeBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/home";
import SimprTataRuangBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/tata_ruang";
import SimprStrukturRuangBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/struktur_ruang";
import SimprRegulasiBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/regulasi";
import SimprPengaduanBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/pengaduan";
import SimprPersyaratanBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/persyaratan";
import SimprMenuBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/menu";
import SimprPanduanBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/panduan";
import SimprDataBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/data";
import SimprDataBprbBprbScreen from "./screens/@admin/@simpr/_@bprb/@public/data_bprb";

// test
import TestScreen from "./screens/@test";
/*------------------------------------------------------------------
[End Screen]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Notifications]
-------------------------------------------------------------------*/
import firebase from 'firebase/app';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component'
/*------------------------------------------------------------------
[End Notifications]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, console_dev_line } from "./functions";
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import './style/animation/node.animation.css';
import './style/general/node.general.css';
import './style/components/node.components.css';
import './style/elements/node.elements.css';
import './style/style/node.style.css';
import 'react-notifications-component/dist/theme.css'
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const App = () => {
	
	/*--------------------------------------------------------------
	[Storage]
	---------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');

	let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
	/*--------------------------------------------------------------
	[End Storage]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Context]
	---------------------------------------------------------------*/
	const [token, set_token] = useState(STORAGE_TOKEN === undefined ? ___token : STORAGE_TOKEN)
	const [user, set_user] = useState(STORAGE_USER === undefined ? ___user : STORAGE_USER)
	const [notification, set_notification] = useState(___notification);
	const [location, set_location] = useState(___location);
	/*--------------------------------------------------------------
	[End Context]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[State]
	---------------------------------------------------------------*/
	const [fmc_token, set_fmc_token] = useState(null);
	const [os, set_os] = useState(null);
	const [refresh, set_refresh] = useState('');
	const [loading_generate, set_loading_generate] = useState(false);
	const [loading, set_loading] = useState(false);
	const [error, set_error] = useState('');
	const [progress, set_progress] = useState('');

	const [setting, set_setting] = useState('');
	const [home, set_home] = useState('');
	/*--------------------------------------------------------------
	[End State]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Firebase]
	---------------------------------------------------------------*/
	const messaging = firebase.messaging();

	messaging.onMessage((payload) => {

		console_dev_line('----------------------------------------------------------');
        console_dev_line('@app_fmc_notification');
        console_dev_line('----------------------------------------------------------');
        console_dev_line(JSON.stringify(payload, undefined, 2))

		if(payload.data){
			store.addNotification({
				title: payload.notification.title,
				message: payload.notification.body,
				type: "info",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
				  duration: 5000,
				  onScreen: true
				}
			});
		}
		
	});

	const _fmc_token = async () => {

		try {
	
			const token = await messaging.getToken();
			set_fmc_token(token)
			console_dev_line('----------------------------------------------------------');
			console_dev_line('@app_fmc_token');
			console_dev_line('----------------------------------------------------------');
			console_dev_line(token)
	
	  	} catch (error) {

			console.error(error);
	  
		}
	
	}
	/*--------------------------------------------------------------
	[End Firebase]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Socket]
	---------------------------------------------------------------*/
	const _socket = (storageUserParams) => {

		// all online ----------------------------------------------
		socket.on('all_online', (data) => {
			console_dev_line('----------------------------------------------------------');
			console_dev_line('@all_online');
			console_dev_line('----------------------------------------------------------');
			console_dev_line(data)
		});
			
		socket.emit('all_online', 'room_all_online');
		
	}
	/*--------------------------------------------------------------
	[End Socket]
	----------------------------------------------------------------/

	/*--------------------------------------------------------------
	[API]
	---------------------------------------------------------------*/
    const _setting = () => {

		if(loading === true){
			return
		}

		set_loading(true);

		API_GET_PUBLIC('client/setting__________')
        .then((response) => {
			if(response.data.result === 'success'){
				// console.log('setting : ', response.data)
                set_setting(response.data.data[0])
            }else if(response.data.error){
                set_error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            set_error(e.message)
        }).finally(() => {
			set_loading(false)
		})

	}
	
	const _home = () => {

		if(loading === true){
			return
		}

		set_loading(true);

		API_GET_PUBLIC('client/home__________')
        .then((response) => {
			if(response.data.result === 'success'){
				// console.log('home : ', response.data)
                set_home(response.data.data)
            }else if(response.data.error){
                set_error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            set_error(e.message)
        }).finally(() => {
			set_loading(false)
		})

    }

	const _login = () => {

		API_LOGIN('login/generate__________', {
			id_key: user[0].id_key,
			bamboo: user[0].bamboo,
			username: user[0].username,
			status: user[0].status,
			verified: user[0].verified,
		})
        .then((response) => {
			console_dev('generate', response.data)
			if(response.data.result === 'success'){
				_loading_token_generate()
                reactLocalStorage.set('@token', response.data.data);
                reactLocalStorage.set('@user', JSON.stringify(response.data.user));
				set_token(response.data.data)
				set_user(response.data.user)
				API_TOKEN(response.data.data)
            }else if(response.data.error){
                set_error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            set_error(e.message)
        }).finally(() => {
			set_loading(false)
		})

    }
	/*--------------------------------------------------------------
	[End API]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Storage]
	---------------------------------------------------------------*/
	const _STORAGE_USER = () => {

        if(STORAGE_USER){
            
			console_dev_line('----------------------------------------------------------');
			console_dev_line('@storage_user');
			console_dev_line('----------------------------------------------------------');
			console_dev_line(STORAGE_USER)

            let bamboo_storage = STORAGE_USER[0].bamboo;
            let level_storage = STORAGE_USER[0].level;
            
            if(bamboo_storage && level_storage){
				_socket(STORAGE_USER[0])
            }

        }
        
    }
	/*--------------------------------------------------------------
	[End Storage]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[OS]
	---------------------------------------------------------------*/
	const _os = () => {

		let userAgent = window.navigator.userAgent,
			platform = window.navigator.platform,
			macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'],
			os = null;

		if (macosPlatforms.indexOf(platform) !== -1) {
			os = 'Mac';
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			os = 'iOS';
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			os = 'Windows';
		} else if (/Android/.test(userAgent)) {
			os = 'Android';
		} else if (!os && /Linux/.test(platform)) {
			os = 'Linux';
		}

		console_dev_line('----------------------------------------------------------');
		console_dev_line('@operating_system');
		console_dev_line('----------------------------------------------------------');
		console_dev_line(os)

		set_os(os)

	}
	/*--------------------------------------------------------------
	[End OS]
	---------------------------------------------------------------*/

	const _scroll = () => {
		return {
		   __html: `
		   <style>
	   
				@media (min-width: 1024px){

					::-webkit-scrollbar {
						width: 5px;
						height: 5px;
					}

					::-webkit-scrollbar-track {
						background: transparent; 
					}

					::-webkit-scrollbar-thumb {
						background: #eee; 
						transition: 0.2s;
					}

					::-webkit-scrollbar-thumb:hover {
						background: #ddd; 
					}

				}

			</style>`    
		};
	}; 

	/*--------------------------------------------------------------
	[Error]
	---------------------------------------------------------------*/
	const _error = () => {
		
		if(error){

			return setTimeout(() => {
				set_error('')
			}, 7000);

		}

	}
	/*--------------------------------------------------------------
	[End Error]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Generate Token]
	---------------------------------------------------------------*/
	const _loading_token_generate = () => {
		set_error('')
		set_loading_generate(true)
		setTimeout(() => {
			set_loading_generate(false) 
		}, 3000)

	}
	/*--------------------------------------------------------------
	[End Generate Token]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Progress]
	---------------------------------------------------------------*/
	const _progress_finish = () => {

		setTimeout(() => {
			set_progress('') 
		}, 1500)

	}
	/*--------------------------------------------------------------
	[End Progress]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Devices]
	---------------------------------------------------------------*/
	const _device = () => {

		if (isBrowser) {
			// set_error('in Browser')
		}else if (isMobile) {
			// set_error('in Mobile')
		}else{
			set_error('in Another Device')
		}

	}
	/*--------------------------------------------------------------
	[End Devices]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[useEffect]
	---------------------------------------------------------------*/
    useEffect(() => {

		_STORAGE_USER()

		_error()

		_os()
		_device()

		_home()
		_setting()

		_fmc_token()

		// reactLocalStorage.clear();

		// console.log('token context : ', token)
		// console.log('user context : ', user)
		// console.log('notification context : ', notification)
		// console.log('location context : ', location)

    }, [refresh])

	useEffect(() => {

		if(error === 'Token Denied'){
			if(STORAGE_USER !== undefined){
				// STORAGE_USER[0].e_account === 'e_all' ?
				// 	_login()
				// : 
				reactLocalStorage.clear();
			}
		}else{
			_error()
		}

	}, [error])
	/*--------------------------------------------------------------
	[End UseEffect]
	---------------------------------------------------------------*/

	/*--------------------------------------------------------------
	[Render]
	---------------------------------------------------------------*/
	return (
		<>
			<Provider store={redux}>
				<TokenContext.Provider value={{token, set_token}}>
					<UserContext.Provider value={{user, set_user}}>
						<NotificationContext.Provider value={{notification, set_notification}}>
							<LocationContext.Provider value={{location, set_location}}>

								{
									error !== 'Token Denied' ?
										<div className={error.length > 0 ? "_snackbar _active" : "_snackbar _deactive"}>
											<div className="_container">
												<div className="_row _center_align">
													<ion-icon name="alert-circle-outline" style={{fontSize: 20}}></ion-icon>
													<div className="_column _push_l_s">
														{error}							
													</div>
													<div onClick={() => set_error('')} className="_push_l_d _push_t_s _cursor_pointer">
														<ion-icon name="close-outline" style={{fontSize: 20}}></ion-icon>
													</div>
												</div>
											</div>
										</div>
									: null
								}

								{

								loading_generate &&
								<div className="_app_loading">
									<div className="_position_middle">
										<ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
										<h2 style={{marginBottom: 6}}><span style={{color: '#118ab2'}}>e-</span>Generate</h2>
										<p>Token di-generate satu jam sekali</p>
									</div>				
								</div>	
								}

								<ReactNotification />						

								{
								
									loading &&
									
									<div className="_loading">
										<div className="line"></div>
										<div className="break dot1"></div>
										<div className="break dot2"></div>
										<div className="break dot3"></div>
									</div>
								
								}

								{
									progress > 0 ?
									
										<div className="_progressbar">
											<div className="_loader"></div>
											<h1 style={{marginBottom: 20}}><span style={{color: '#118ab2'}}>e-</span>Progress</h1>
											<div className="_item">
												<div className="_item_progress" style={{width: `${progress}%`}}>
													<div className="_percent">{`${progress}%`}</div>
												</div>
											</div>
											{
												progress === 100 ?
													_progress_finish()
												: 
													<p className="_push_t_l">Uploading Files . . .</p>
											}
										</div>

									: null
								
								}

								<div dangerouslySetInnerHTML={os !== 'Mac' ? _scroll() : null}></div>

								<Meta loading={loading} setting={setting}/>
								
								<Router>
									
									<Switch>
										
										{/* E_ALL ----------------------------------------------------- */}

										<Route path="/super/login">
											<LoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										{/* <Route path="/super/register">
											<RegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/super/forget/password">
											<ForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/super/activation/redirect">
											<ActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route> */}

										{/* E_FORUM ----------------------------------------------------- */}

										<Route path="/forum/login">
											<ForumLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										<Route path="/forum/register">
											<ForumRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/forum/forget/password">
											<ForumForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/forum/activation/redirect">
											<ForumActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/forum/home">
											<ForumHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/forum/call">
											<ForumCallScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/forum/chat">
											<ForumChatScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/forum/:slug">
											<ForumEntryScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										{/* E_EXPORT ----------------------------------------------------- */}

										<Route path="/export/login">
											<ExportLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										<Route path="/export/register">
											<ExportRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/export/forget/password">
											<ExportForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/export/activation/redirect">
											<ExportActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/export/home">
											<ExportHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/export/payment">
											<ExportPaymentScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										{/* E_OTOMOTIF ----------------------------------------------------- */}

										<Route path="/otomotif/login">
											<OtomotifLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										<Route path="/otomotif/register">
											<OtomotifRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/otomotif/forget/password">
											<OtomotifForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/otomotif/activation/redirect">
											<OtomotifActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/otomotif/home">
											<OtomotifHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/otomotif/payment">
											<OtomotifPaymentScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										{/* E_MEGAMERAH ----------------------------------------------------- */}

										<Route path="/megamerah/login">
											<MegaMerahLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										<Route path="/megamerah/register">
											<MegaMerahRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/megamerah/forget/password">
											<MegaMerahForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/megamerah/activation/redirect">
											<MegaMerahActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/megamerah/home">
											<MegaMerahHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/megamerah/payment">
											<MegaMerahPaymentScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										{/* E_TOUR ----------------------------------------------------- */}

										<Route path="/tour/login">
											<TourLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										<Route path="/tour/register">
											<TourRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/tour/forget/password">
											<TourForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/tour/activation/redirect">
											<TourActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/tour/home">
											<TourHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/tour/payment">
											<TourPaymentScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										{/* E_SCHOOL ----------------------------------------------------- */}

										<Route path="/school/login">
											<SchoolLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										{/* <Route path="/school/register">
											<SchoolRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route> */}

										<Route path="/school/forget/password">
											<SchoolForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/school/activation/redirect">
											<SchoolActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/school/home">
											<SchoolHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/school/payment">
											<SchoolPaymentScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										{/* E_SIMS ----------------------------------------------------- */}

										<Route path="/sims/login">
											<SimsLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										<Route path="/sims/register">
											<SimsRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/sims/forget/password">
											<SimsForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/sims/activation/redirect">
											<SimsActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/sims/export/rapor">
											<SimsExportRaporScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>
										
										<Route path="/sims/export/guru">
											<SimsExportGuruScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/sims/export/siswa">
											<SimsExportSiswaScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										{/* <Route path="/sims/export/nilai">
											<SimsExportNilaiScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/sims/export/keuangan">
											<SimsExportKeuanganScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route> */}

										<Route path="/sims/export/penggajian">
											<SimsExportPenggajianScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										{/* E_SIMPR ----------------------------------------------------- */}

										<Route path="/simpr/login">
											<SimprLoginScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										{/* <Route path="/simpr/register">
											<SimprRegisterScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/simpr/forget/password">
											<SimprForgetPasswordScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/simpr/activation/redirect">
											<SimprActivationRedirectScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route> */}

										<Route path="/simpr/home">
											<SimprHomeScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										{/* E-BPRB ----------------------------------------------------- */}

										<Route path="/simpr/bprb/login">
											<SimprLoginBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>
							
										{/* <Route path="/simpr/bprb/register">
											<SimprRegisterBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/simpr/bprb/forget/password">
											<SimprForgetPasswordBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												setting={setting}
											/>
										</Route>

										<Route path="/simpr/bprb/activation/redirect">
											<SimprActivationRedirectBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route> */}

										<Route path="/simpr/bprb/home">
											<SimprHomeBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/tata_ruang">
											<SimprTataRuangBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/struktur_ruang">
											<SimprStrukturRuangBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/panduan">
											<SimprPanduanBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/regulasi">
											<SimprRegulasiBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/pengaduan">
											<SimprPengaduanBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/persyaratan">
											<SimprPersyaratanBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/menu">
											<SimprMenuBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route exact path="/simpr/bprb/data">
											<SimprDataBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
										</Route>

										<Route path="/simpr/bprb/data/bprb">
											<SimprDataBprbBprbScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
												progress={(e) => set_progress(e)}
											/>
										</Route>
										

										{/* ADMIN ROUTES ----------------------------------------------- */}

										<Route exact path="/">

											<Detector
												render={({ online }) => (
													<div className={online ? "normal" : "warning"}>
														{

															online ?	

																STORAGE_USER && STORAGE_USER[0].verified === null ?
																	
																	STORAGE_USER ? 
																		
																		STORAGE_USER[0].e_account === 'e_all' ?
																
																			<ActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_forum' ?
																
																			<ForumActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_export' ?
																
																			<ExportActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_otomotif' ?
																
																			<OtomotifActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_megamerah' ?
																
																			<MegamerahActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_tour' ?
																
																			<TourActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_school' ?
																
																			<SchoolActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>

																		: STORAGE_USER[0].e_account === 'e_sims' ?

																			<SimsActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>
																			
																		: STORAGE_USER[0].e_account === 'e_simpr' ?

																			<SimprActivationScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>
																			
																		: STORAGE_USER[0].e_account === 'e_simpr_bprb' ?

																			<SimprActivationBprbScreen 
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)} 
																			/>
																			
																		: null

																	:

																		<RedirectScreen />
																: 

																	STORAGE_USER ? 

																		STORAGE_USER[0].e_account === 'e_all' ?

																			<AdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_forum' ?

																			<ForumAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_export' ?

																			<ExportAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_otomotif' ?

																			<OtomotifAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_megamerah' ?

																			<MegaMerahAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_tour' ?
																			
																			<TourAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_school' ?
																			
																			<SchoolAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_sims' ?

																			<SimsAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_simpr' ?

																			<SimprAdminScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: STORAGE_USER[0].e_account === 'e_simpr_bprb' ?

																			<SimprAdminBprbScreen
																				loading={(e) => {set_loading(e)}}
																				error={(e) => set_error(e)}
																				progress={(e) => set_progress(e)}
																				setting={setting}
																				fmc_token={fmc_token}
																			/>

																		: null

																	:

																		<RedirectScreen />
															:

																<OfflineScreen />
														
														}
													</div>
												)}
											/>

										</Route>
										
										{/* CLIENT ----------------------------------------------------- */}

										<Route exact path="/home">
											{
												setting.maintenance === 'launch' ?
													home &&
													<>
														<Navbar 
															setting={setting}
															pages={home.pages}
															profile={home.profile}
															modal={home.modal}
															hukum={home.hukum}
															pelayanan={home.pelayanan}
															contact={home.contact}
															about={home.about}
															footer={home.footer}
														/>
														<Header
															error={(e) => set_error(e)} 
															header_text={home.header_text}
															header={home.header}
															header_slider_background={home.header_slider_background}
															header_video={home.header_video}
															gallery={home.gallery} 
															setting={setting}
														/>
														<Content
															ads={home.ads}
															profile_personal={home.profile_personal}
															services={home.services}
															testimonial={home.testimonial}
															images={home.images}
															gallery={home.gallery}
															video={home.video}
															bulletin={home.bulletin}
															event={home.event}
															article={home.article}
															news={home.news}
															contact={home.contact}
															about={home.about}
														/>
														<Footer 
															footer={home.footer} 
															faq={home.faq} 
															privacy={home.privacy}
															setting={setting}
														/>
													</>
												: setting.maintenance === 'maintenance' ?

													<>
														<div className="_progressbar">
															<div className="_loader"></div>
															<div style={{padding: 20}}>
																<h1>Maintenance</h1>
																<p>Sedang Maintenance, kembali lagi beberapa saat.</p>
															</div>
														</div>
													</>

												: null
											}
										</Route>

										<Route path="/gallery">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<GalleryScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>

										<Route path="/images">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												program={home.program}
												mitra={home.mitra}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<ImagesScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>

										<Route path="/video">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<VideoScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/services">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<ServicesScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/profile">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<ProfileScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/testimonial">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<TestimonialScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/post/:slug">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<PostScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/bulletin">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<PostBulletinScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/event">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<PostEventScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/news">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<PostNewsScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										<Route path="/article">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<PostArticleScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>

										<Route path="/pages/:slug">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<PagesScreen 
												loading={(e) => set_loading(e)}
												error={(e) => set_error(e)}
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>

										<Route path="/mail">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<MailScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>

										<Route path="/guest">
											<Navbar 
												setting={setting}
												pages={home.pages}
												profile={home.profile}
												modal={home.modal}
												hukum={home.hukum}
												pelayanan={home.pelayanan}
												contact={home.contact}
												about={home.about}
												footer={home.footer}
											/>
											<GuestScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)} 
											/>
											<Footer 
												footer={home.footer} 
												faq={home.faq} 
												privacy={home.privacy}
												setting={setting}
											/>
										</Route>
										
										{/* TEST ----------------------------------------------------- */}
										<Route path="/test">
											<TestScreen 
												loading={(e) => {set_loading(e)}}
												error={(e) => set_error(e)}
												progress={(e) => set_progress(e)} 
											/>
										</Route>

										{/* DEFAULT -------------------------------------------------- */}
										<Route>
											<NotFoundScreen />
										</Route>
									</Switch>

								</Router>
							</LocationContext.Provider>
						</NotificationContext.Provider>
					</UserContext.Provider>
				</TokenContext.Provider>
			</Provider>
		</>
	);
	/*--------------------------------------------------------------
	[End Render]
	---------------------------------------------------------------*/
	
}

export default App;
